import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Outlet } from 'react-router-dom'
import { selectSpacePlansInfo } from './store'
import Header from './Header'
import TabsWrap from './Tabs'

export const Component = ({ id, user, spacePlan }) => {
  const { url, status, generating, title, type } = spacePlan

  return (
    <div>
      <Header {...{ id, type, status, title, user, generating, url }} />
      {id && <TabsWrap {...{ id, spacePlan, user }} />}
      <Outlet />
    </div>
  )
}

Component.propTypes = {
  user: PropTypes.shape({}).isRequired,
  id: PropTypes.string,
  spacePlan: PropTypes.shape({
    url: PropTypes.string,
    status: PropTypes.string,
    generating: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
  }),
}

Component.defaultProps = {
  id: null,
  spacePlan: {},
}

const mapStateToProps = (state, ownProps) => ({
  spacePlan: selectSpacePlansInfo(state, ownProps.id) || {},
})

export default connect(mapStateToProps)(Component)
